import { useMemo } from 'react'

import { Box, Grid } from '@material-ui/core'
import EmailIcon from '@material-ui/icons/Email'
import FacebookIcon from '@material-ui/icons/Facebook'
import InstagramIcon from '@material-ui/icons/Instagram'
import LanguageIcon from '@material-ui/icons/Language'
import LocationIcon from '@material-ui/icons/LocationOn'
import PersonIcon from '@material-ui/icons/Person'
import PhoneIcon from '@material-ui/icons/Phone'
import TwitterIcon from '@material-ui/icons/Twitter'
import YouTubeIcon from '@material-ui/icons/YouTube'

import SimpleCard from '~/components/cards/SimpleCard'
import ReactHtmlParser from '~/components/shared/ReactHtmlParser'
import { Title } from '~/components/shared/Text'
import { DealerDetails } from '~/views/Dealer/DealerProfile/DetailSection/DealerDeatails'
import { DealerMap } from '~/views/Dealer/DealerProfile/DetailSection/DealerMap'
import { DealerPhoto } from '~/views/Dealer/DealerProfile/DetailSection/DealerPhoto'

import TikTokIcon from '~/assets/icons/tiktok.svg?sprite'

function DealerDetailsSection({ data, dealer }) {
  const items = useMemo(
    () =>
      [
        data.contact_name && {
          icon: PersonIcon,
          primary: data.contact_name
        },
        data.address && {
          icon: LocationIcon,
          primary: data.address.label
        },
        data.phone && {
          icon: PhoneIcon,
          primary: data.phone,
          href: `tel: ${data.phone}`
        },
        data.email && {
          icon: EmailIcon,
          primary: data.email,
          href: `mailto: ${data.email}`
        },
        data.website && {
          icon: LanguageIcon,
          primary: data.website,
          href: data.website
        },
        data.facebook && {
          icon: FacebookIcon,
          primary: data.facebook,
          href: data.facebook
        },
        data.instagram && {
          icon: InstagramIcon,
          primary: data.instagram,
          href: data.instagram
        },
        data.twitter && {
          icon: TwitterIcon,
          primary: data.twitter,
          href: data.twitter
        },
        data.tiktok && {
          icon: TikTokIcon,
          primary: data.tiktok,
          href: data.tiktok
        },
        data.youtube && {
          icon: YouTubeIcon,
          primary: data.youtube,
          href: data.youtube
        }
      ].filter(Boolean),
    [data]
  )

  return (
    <SimpleCard>
      <Grid container spacing={2}>
        <Grid item xs={12} xl={2} md={4}>
          <DealerPhoto data={data} dealer={dealer} />
        </Grid>
        <Grid item xs={12} xl={5} md={8}>
          <DealerDetails data={data} items={items} />
        </Grid>
        <Grid item xs={12} xl={5} md={12}>
          <DealerMap data={data} />
        </Grid>
        {data.description && (
          <Grid item xs={12}>
            <Title variant="h2" fontWeight={500} fontSize={20}>
              Description
            </Title>
            <Box className="format-parsed-text">
              <ReactHtmlParser data={data.description} />
            </Box>
          </Grid>
        )}
      </Grid>
    </SimpleCard>
  )
}

export default DealerDetailsSection
